<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
		<g :fill="color">
			<path d="M11.1547804,12.4889404 L14.8891628,15.6572275 C15.2839795,15.9921938 15.3324977,16.5837998 14.9975314,16.9786164 C14.662565,17.373433 14.0709591,17.4219513 13.6761424,17.086985 L9.15227219,13.2488887 C8.72949393,12.8901994 8.70866231,12.2449537 9.10742388,11.8597412 L13.6312941,7.4895824 C14.0036824,7.12984702 14.597186,7.14010427 14.9569214,7.51249261 C15.3166567,7.88488095 15.3063995,8.47838449 14.9340112,8.83811987 L11.1547804,12.4889404 Z" transform="scale(1 -1) rotate(1 1417.793 0)"/>
			<path d="M12.5,24.6875 C5.76902961,24.6875 0.3125,19.2309704 0.3125,12.5 C0.3125,5.76902961 5.76902961,0.3125 12.5,0.3125 C19.2309704,0.3125 24.6875,5.76902961 24.6875,12.5 C24.6875,19.2309704 19.2309704,24.6875 12.5,24.6875 Z M12.5,24.0625 C18.8857924,24.0625 24.0625,18.8857924 24.0625,12.5 C24.0625,6.11420758 18.8857924,0.9375 12.5,0.9375 C6.11420758,0.9375 0.9375,6.11420758 0.9375,12.5 C0.9375,18.8857924 6.11420758,24.0625 12.5,24.0625 Z"/>
		</g>
	</svg>
</template>
<script>
export default {
	name: 'arrow-left',
	props: {
		color: {
			type: String,
			default: '',
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/svg/ArrowLeft.vue